import { formatJapaneseDate } from "./formatTimeUtils";

/**
 * Issue #70: マイページの更新日の帯に「何を出すか」を決める単一の情報源。
 *
 * 表示できるのは以下の2ケースのみ。
 *   - 有料会員（source: "paid"）        → 「次回更新日 YYYY年M月D日」
 *     （次回更新停止中 cancelAtPeriodEnd: true なら「ご利用期限 YYYY年M月D日まで」#110）
 *   - 無料付与ユーザー（source: "free"）→ 「無料ご利用期間 YYYY年M月D日まで」
 *
 * それ以外（source: "none" / 日付が欠落・不正 / membership 自体が無い）は null を返す。
 * 呼び出し側は null なら帯自体を描画しない。「未定」等のプレースホルダは置かない方針
 * （2026-08-20 決定）。仕様: docs/plans/202608/70-membership-renewal-date.md
 *
 * @returns {{label: string, value: string}|null}
 */
export const resolveMembershipDisplay = (membership) => {
  if (!membership || typeof membership !== "object") return null;

  if (membership.source === "paid") {
    const value = formatJapaneseDate(membership.currentPeriodEnd);
    if (!value) return null;
    // #110: 次回更新停止中は期間終了で解約されるため「ご利用期限 …まで」と表示する
    if (membership.cancelAtPeriodEnd === true) {
      return { label: "ご利用期限", value: `${value}まで` };
    }
    return { label: "次回更新日", value };
  }

  if (membership.source === "free") {
    const value = formatJapaneseDate(membership.freeAccessExpiresAt);
    return value ? { label: "無料ご利用期間", value: `${value}まで` } : null;
  }

  return null;
};
